module.exports = __webpack_public_path__ + "9b4bd2abac85fcf142600c9477bbab1d.svg";